import React, { useEffect, useCallback, useState, forwardRef } from 'react';
import Textarea from '@mui/joy/Textarea';
import FormControl from '@mui/joy/FormControl';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Input from '@mui/joy/Input';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import { getSettings, updateSettings } from '../../Api/common';

const schema = yup.object({
    copyRightAr: yup.string().required("هذا الحقل مطلوب"),
    copyRightEn: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function CopyRightComponent() {
    const [content, setContent] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            copyRightAr: "",
            copyRightEn: "",
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const getAllContent = useCallback(async () => {
        const res = await getSettings()
        if (res) {
            setValue('copyRightAr', res.copyRightAr)
            setValue('copyRightEn', res.copyRightEn)
        }
    }, []);

    const submitcontent = async (data) => {
        setLoading(true)
        try {
            const res = await updateSettings(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم تعديل محتوى من نحن بنجاح")
                setLoading(false)
                getAllContent();
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }


    useEffect(() => {
        getAllContent();
    }, [getAllContent])

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            <form onSubmit={handleSubmit(submitcontent)}>
                <FormControl>
                <Input
                        type='text'
                        placeholder="حقوق الملكية"
                        sx={{
                            marginTop: '10px',
                            height: '50px',
                            borderRadius: '25px'
                        }}
                        {...register('copyRightAr')}
                    />
                    {/* <Textarea
                        placeholder="حقوق الملكية"
                        minRows={8}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#E6E6E6',
                            },
                            background: '#F7F9FB',
                            marginBottom: '20px'
                        }}
                        {...register('copyRightAr')}
                    /> */}
                    {errors.copyRightAr &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.copyRightAr?.message}</Typography>
                    }
                </FormControl>

                <FormControl sx={{ direction: 'ltr' }}>
                    <Input
                        type='text'
                        placeholder="Copy Right"
                        sx={{
                            marginTop: '10px',
                            height: '50px',
                            borderRadius: '25px'
                        }}
                        {...register('copyRightEn')}
                    />
                    {/* <Textarea
                        placeholder="Copy Right"
                        minRows={8}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#E6E6E6',
                            },
                            background: '#F7F9FB',
                            marginBottom: '20px'
                        }}
                        {...register('copyRightEn')}
                    /> */}
                    {errors.copyRightEn &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.copyRightEn?.message}</Typography>
                    }
                </FormControl>

                {/* <FormControl>
                    <Textarea
                        placeholder="Aboout Us"
                        minRows={8}
                        sx={{
                            '--Textarea-focusedInset': 'var(--any, )',
                            '--Textarea-focusedThickness': '0.25rem',
                            '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                            '&::before': {
                                transition: 'box-shadow .15s ease-in-out',
                            },
                            '&:focus-within': {
                                borderColor: '#E6E6E6',
                            },
                            background: '#F7F9FB',
                            direction: 'ltr'
                        }}
                    />
                </FormControl> */}

                <Button
                    variant='solid'
                    type='submit'
                    loading={loading}
                    sx={{ marginTop: '30px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px' }}>
                    تجديد المحتوى
                </Button>
            </form>
        </>
    )
}